module.exports = __webpack_public_path__ + "static/media/buy_request_details_help_8.7ba0cbb8.png";